var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeWidth: 1.5,
    d: "M6.667 13.334A2.675 2.675 0 0 0 4 16c0 1.467 1.2 2.667 2.667 2.667 1.466 0 2.666-1.2 2.666-2.667 0-1.466-1.2-2.666-2.666-2.666ZM25.333 13.334A2.675 2.675 0 0 0 22.667 16c0 1.467 1.2 2.667 2.666 2.667C26.8 18.667 28 17.467 28 16c0-1.466-1.2-2.666-2.667-2.666Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4ECDC4",
    strokeWidth: 1.5,
    d: "M16 13.334A2.675 2.675 0 0 0 13.334 16c0 1.467 1.2 2.667 2.666 2.667 1.467 0 2.667-1.2 2.667-2.667 0-1.466-1.2-2.666-2.667-2.666Z"
  })));
};
export default SvgMore;